import { NoDataFound } from 'assets/AssetIndex';

const ComingSoon = ({ isTextBold }) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-5">
      <img src={NoDataFound} alt="comingSoon" />
      <div className="text-center">
        <p
          className={`${
            isTextBold ? 'text-2xl font-semibold' : 'text-xl'
          } text-[#474747]`}
        >
          Coming Soon
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
